var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-footer',{staticClass:"foot"},[_vm._v(" "+_vm._s(_vm.platformValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }